import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_NO.json';
import recipes from './COOKING_RECIPES_NO.json';
import videos from './COOKING_VIDEOS_NO.json';

export const COOKING_DATA_NO: ServiceData = {
  articles,
  recipes,
  videos,
};
